import { Presential } from '../../../@academy/catalog/models/Presential.model';

export class ExchangePresential extends Presential {
  documentsPostcomLink?: string;
  documentsPrecomLink?: string;
  keyMessages?: string[];
  linkContent1?: string;
  linkContent2?: string;
  recommendations?: string;
  teachingMethod?: string;
  resultsMonitoring?: string;

  targetPopulation?: string;
  titleContent1?: string;
  titleContent2?: string;
  youtubeTrailerId?: string;
}
